import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireRelativeTime } from "../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/relativeTime.js";
var relativeTimeExports = requireRelativeTime();
const relativeTime = /* @__PURE__ */ getDefaultExportFromCjs(relativeTimeExports);
export {
  relativeTime as default
};
//# sourceMappingURL=relativeTime.js.map
